import { RootState } from '../Store';

export const selectAgentStatus = (state: RootState) => state.agent.status;
export const selectAgentLastRegistered = (state: RootState) => state.agent.lastAgent;
export const selectAgentLastTxHash = (state: RootState) => state.agent.lastTxHash;
export const selectAgentRejection = (state: RootState) => state.agent.rejection;

export const selectAgentIsSubmitting = (state: RootState) =>
  state.agent.status === 'submitting';

export const selectAgentSubsidyUnavailable = (state: RootState) =>
  state.agent.rejection?.kind === 'subsidy_unavailable'
    ? state.agent.rejection
    : null;

export const selectAgentPendingOwnerPaid = (state: RootState) =>
  state.agent.pendingAgent;

export const selectAgentInsufficientFunds = (state: RootState) =>
  state.agent.insufficientFunds;

export const selectAgentDisplayNameTaken = (state: RootState) =>
  state.agent.rejection?.kind === 'display_name_taken';

// "My agents" listing selectors — Ring 1.
export const selectOwnedAgents = (state: RootState) => state.agent.ownedAgents;
export const selectOwnedAgentsStatus = (state: RootState) => state.agent.ownedAgentsStatus;
export const selectOwnedAgentsError = (state: RootState) => state.agent.ownedAgentsError;

// Discover selectors — Ring 2.
export const selectDiscoverAgents = (state: RootState) => state.agent.discoverAgents;
export const selectDiscoverStatus = (state: RootState) => state.agent.discoverStatus;
export const selectDiscoverError = (state: RootState) => state.agent.discoverError;
export const selectDiscoverNextCursor = (state: RootState) => state.agent.discoverNextCursor;
export const selectDiscoverTotal = (state: RootState) => state.agent.discoverTotal;
export const selectDiscoverSpotlights = (state: RootState) => state.agent.discoverSpotlights;
export const selectDiscoverAppliedCapabilities = (state: RootState) =>
  state.agent.discoverAppliedCapabilities;
export const selectDiscoverAppliedChains = (state: RootState) =>
  state.agent.discoverAppliedChains;
export const selectDiscoverIsLoading = (state: RootState) =>
  state.agent.discoverStatus === 'loading';
export const selectDiscoverIsLoadingMore = (state: RootState) =>
  state.agent.discoverStatus === 'loading_more';

// Edit selectors — Ring 2.5.
export const selectAgentEditDetail = (state: RootState) => state.agent.editDetail;
export const selectAgentEditLoadStatus = (state: RootState) => state.agent.editLoadStatus;
export const selectAgentEditLoadError = (state: RootState) => state.agent.editLoadError;
export const selectAgentEditSaveStatus = (state: RootState) => state.agent.editSaveStatus;
export const selectAgentEditSaveRejection = (state: RootState) => state.agent.editSaveRejection;
export const selectEndpointSaveStatus = (state: RootState) => state.agent.endpointSaveStatus;
export const selectEndpointSaveRejection = (state: RootState) => state.agent.endpointSaveRejection;

// Per-chain wallet CRUD status. Shared spinner across add / promote /
// delete on the edit page — one card, one status.
export const selectWalletSaveStatus = (state: RootState) => state.agent.walletSaveStatus;
export const selectWalletSaveRejection = (state: RootState) => state.agent.walletSaveRejection;

// Receipts — Ring 3 Phase 1. Selectors are keyed by provider agent
// user id so more than one agent's list can coexist in the store.
export const selectAgentReceipts = (agentUserId: string) => (state: RootState) =>
  state.agent.receiptsByAgent[agentUserId]?.receipts ?? [];
export const selectAgentReceiptsStatus = (agentUserId: string) => (state: RootState) =>
  state.agent.receiptsByAgent[agentUserId]?.status ?? 'idle';
export const selectAgentReceiptsError = (agentUserId: string) => (state: RootState) =>
  state.agent.receiptsByAgent[agentUserId]?.error ?? null;
export const selectAgentReceiptsNextCursor = (agentUserId: string) => (state: RootState) =>
  state.agent.receiptsByAgent[agentUserId]?.nextCursor ?? null;
